exports.default = require(`./${process.env.REACT_APP_ENV}.config.js`);
module.exports = require(`./${process.env.REACT_APP_ENV}.config.js`);
